import styled from 'styled-components';
import { Loader } from '@styled-icons/boxicons-regular/Loader';

export const SpinnerIcon = styled(Loader)`
  width: 1rem;
  margin: auto;
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;
